import { useEffect, useRef, useState } from 'react';
import { playTestTone } from '../services/audioPlayback';

export default function SoundCheck() {
  const context = useRef<AudioContext | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  useEffect(() => () => { void context.current?.close().catch(() => {}); }, []);
  const test = async () => {
    let played = false;
    try {
      context.current ||= new (window.AudioContext || (window as any).webkitAudioContext)();
      played = await playTestTone(context.current);
    } catch { /* Explicit retry remains available when WebAudio is unavailable. */ }
    setMessage(played ? 'Bip demandé. Si tu ne l’entends pas, vérifie le volume et la sortie audio.' : 'Son bloqué. Clique pour réessayer.');
  };
  return <div className="my-3 text-sm"><button className="btn-secondary" onClick={() => void test()}>Tester le son</button>{message && <p role="status" className="text-dark-300 mt-2">{message}</p>}</div>;
}
